<template>
  <div class="common-dialog__prompt">
    <div class="dialog-content__hd">
      <span>{{ $attrs.header }}</span>

      <div class="header-close-icon cur-pointer">
        <svg-icon icon-class="close" @click="$emit('model-input', false)" />
      </div>
    </div>
    <div class="dialog-content__bd">
      <textarea
        v-model="reson"
        :placeholder="`请输入${$attrs.header}...`"
      ></textarea>
    </div>
    <div v-if="!$attrs.hiddenButton" class="dialog-content__ft">
      <button @click="$emit('confirm', reson)">{{ $attrs.confirmText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      reson: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.common-dialog__prompt {
  width: 400px;
  padding: 25px;

  .dialog-content__hd {
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 16px;
    color: #212832;

    .header-close-icon {
      position: absolute;
      right: 25px;
      top: 25px;
      width: 24px;
      height: 24px;
      line-height: 1;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .dialog-content__bd {
    margin-top: 15px;
    height: 200px;
    background: #f9fafb;
    border: 1px solid #f1f3f6;

    textarea {
      width: 100%;
      height: 100%;
      padding: 22px 24px;
      resize: none;
      border: 0;
      outline: 0;
      background: none;
      line-height: 22px;
      font-size: 14px;
      color: #5d646f;
    }
  }

  .dialog-content__ft {
    padding-top: 25px;
    text-align: center;

    button {
      width: 140px;
      height: 40px;
      border: 0;
      // background: var(--primary);
      background: #4068f7;
      font-size: 15px;
      font-weight: bold;
      border-radius: 5px;
      user-select: none;
      cursor: pointer;
      color: #fff;

      &:active {
        background: #395dde;
      }
    }
  }
}
</style>